/** Fired on same tab when booking is saved to localStorage (Calendly embed completed). */
export const ONBOARDING_CALL_CTA_BOOKED_EVENT = 'vt-onboarding-call-cta-booked'

export function onboardingCallCtaBookedStorageKey(userId: string, companyId: string): string {
  return `vt_onboarding_call_cta_booked_${userId}_${companyId}`
}

export function isOnboardingCallCtaBooked(userId: string | undefined, companyId: string | undefined): boolean {
  if (!userId || !companyId) return false
  try {
    return localStorage.getItem(onboardingCallCtaBookedStorageKey(userId, companyId)) === '1'
  } catch {
    return false
  }
}

export function markOnboardingCallCtaBooked(userId: string, companyId: string): void {
  try {
    localStorage.setItem(onboardingCallCtaBookedStorageKey(userId, companyId), '1')
  } catch {
    // ignore quota / private mode
  }
  window.dispatchEvent(new CustomEvent(ONBOARDING_CALL_CTA_BOOKED_EVENT))
}
